import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=6d903616"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d903616')) {
      api.createRecord('6d903616', component.options)
    } else {
      api.reload('6d903616', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=6d903616", function () {
      api.rerender('6d903616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/ezpay/Sidebar/Link.vue"
export default component.exports